





















import AbpBase from "@/lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import {
    SaveGoodClinicalPractice
} from "@/api/hd";
import util from "@/lib/util";

@Component({})
export default class extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Object, default: {} }) patient: any;
  form: any = {
    Id:0,
    name:""
  };
  created() {
    this.form.startTime=new Date();
  }
  rules = {
  };
  cancel() {
    (this.$refs.form as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  async save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        this.form.patientId=this.patient.pD_Patient_ID;
        this.form.startTime = this.formatDateTime( this.form.startTime)
        this.form.endTime = this.formatDateTime( this.form.endTime)
        let res = await SaveGoodClinicalPractice(this.form);
        if (res.status == 1) {
          this.$emit("input", false);
          this.$emit("on-success");
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/gcpManage/parts/gcpPractice/practice.vue